import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

import { withRouter, Link, useHistory, useLocation } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import Logo from "../../assets/images/logo-large.png";
import "../../assets/scss/custom/style.css";

import Snackbars from "../../Utils/Snackbars";
import useRequestsWOAccessToken from '../../Utils/useRequestsWOAccessToken';

const ChangePasswordPage = (props) => {
  //meta title
  document.title = 'Change Password';
  const location = useLocation();
  const history = useHistory();
  const { postRequestWOAccessToken } = useRequestsWOAccessToken();

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const [AID, setAID] = React.useState(0);
  const AIDRef = React.useRef(0);

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, 5000);
  };

  // Formik validation
  const validation1 = useFormik({
    enableReinitialize: true,
    initialValues: {
      otp: '',
      password: '',
      confirm_password: '',
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .required('OTP is required')
        .matches(/^\d{4,8}$/, 'OTP must be 4-8 digits'),
      password: Yup.string()
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/\d/, 'Password must contain at least one numeric character')
        .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
        .required('Password is required')
        .min(8, 'Password must be at least 8 characters')
        .max(20, 'Password must be at most 20 characters'),
      confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Both passwords need to be the same!')
        .required('Confirm Password is required'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          a_id: AIDRef.current,
          email_otp: values.otp,
          password: values.password,
          confirm_password: values.confirm_password,
        });

        const res = await postRequestWOAccessToken('change-password', jsonpar);

        if (res && res.code === 200) {
          history.push('/login', { code: 200, status: 'success', message: res.message });
        } else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }

        resetAlertData();
        submit1.disabled = false;
        submit1.textContent = 'Submit';
      } catch (error) {
        console.error("Error : ", error);
      }
    },
  });

  // Resend OTP API
  const resendOTP = async () => {
    const jsonpar = JSON.stringify({
      a_id: AIDRef.current,
    });

    const res = await postRequestWOAccessToken('send-otp', jsonpar);

    if (res && res.code === 200) {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'success',
        message: res.message,
      }));
    } else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  };

  // Fetch AID from location state
  React.useEffect(() => {
    if (location.state && location.state.id) {
      setAID(location.state.id);
      AIDRef.current = location.state.id; // <-- important: persist value for API calls
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
    }
  }, [location.state]);

  return (
    <React.Fragment>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="account-pages bg-green">
        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody>
                  <Link to="/login" className="logo center-logo">
                    <span className="text-center">
                      <img src={Logo} alt="" />
                    </span>
                  </Link>
                  <h4 className="text-center mt-3 mb-3">Change your password ?</h4>

                  <div className="p-2">
                    <Form>
                      <div className="mb-3">
                        <Label className="form-label">{'OTP'} :</Label>
                        <Input
                          name="otp"
                          type="text"
                          placeholder={'Enter OTP'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.otp || ""}
                          invalid={validation1.touched.otp && validation1.errors.otp ? true : false}
                        />
                        {validation1.touched.otp && validation1.errors.otp ? (
                          <FormFeedback type="invalid">{validation1.errors.otp}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">{'Password'} :</Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder={'Enter password'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.password || ""}
                          invalid={validation1.touched.password && validation1.errors.password ? true : false}
                        />
                        {validation1.touched.password && validation1.errors.password ? (
                          <FormFeedback type="invalid">{validation1.errors.password}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">{'Confirm password'} :</Label>
                        <Input
                          name="confirm_password"
                          type="password"
                          placeholder={'Enter confirm password'}
                          onChange={validation1.handleChange}
                          onBlur={validation1.handleBlur}
                          value={validation1.values.confirm_password || ""}
                          invalid={validation1.touched.confirm_password && validation1.errors.confirm_password ? true : false}
                        />
                        {validation1.touched.confirm_password && validation1.errors.confirm_password ? (
                          <FormFeedback type="invalid">{validation1.errors.confirm_password}</FormFeedback>
                        ) : null}
                      </div>
                      <div className="mt-3 d-grid">
                        <button
                          id="submit1"
                          onClick={(e) => {
                            e.preventDefault();
                            validation1.handleSubmit();
                            return false;
                          }}
                          className="btn btn-block" style={{ backgroundColor: '#266199', color: '#fff', border: 'none', width: '100%', padding: '0.5rem 1rem', borderRadius: '0.25rem' }}> {'Submit'} </button>
                      </div>
                    </Form>
                    <div className="form-horizontal">
                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          <Link to="#" className="text-underline" style={{ color: '#266199' }} onClick={(e) => resendOTP()}>
                            {'Click here to resend.'}
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p style={{ color: '#266199' }}>
                  {'Go back to'}{" "}
                  <Link to="login" className="font-weight-medium text-underline">
                    {'Login'}
                  </Link>{" "}
                </p>
                <p style={{ color: '#266199' }}>
                  © {new Date().getFullYear()} Utilize Safety.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ChangePasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ChangePasswordPage);
